module.exports = __webpack_public_path__ + "bae27d08d16b8fd94a7a0bc908384da8.webm";